<template>
      <div>

      <v-autocomplete
        hide-details
        append-icon="search"
        :label="label"
        :loading="loading"
        :items="items"
        clearable=""
        item-text="text"
        cache-items=""
        item-value="id"
        :search-input.sync="search"
        v-model="CariKod"
        :required="required"
        :rules="rules"
        readonly=false
      ></v-autocomplete>

      </div>
</template>

<script>
import auth from '../../../../api/auth'

export default {
    props:["value","required","rules"],

    computed: {
      CariKod: {
        get: function () {

          this.KodAciklamaAra(this.value);
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue )
        },
      },
    },


    data () {
      return {
        loading: false,
        items: [],
        search: null,
        label: this.$t('Currentcode_label')

      }
    },

  watch: {
    search (val) {
      val && this.querySelections(val)
    }
  },
  methods: {

    querySelections (v) {


      if ((v!=null) && (v.length > 3)) {
        this.loading = true
        setTimeout(() => {
          this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
            q: escape(v)
          }, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

            this.items = response.body

          }, (response) => {
            if (response.status === 0) {
              //this.Success = false
              //this.Error = 'Service Unavailable'
            } else {
                //this.Success = false
                //this.Error = response.statusText
              }
            })
              this.loading = false
            }, 750)
        }
    },

    KodAciklamaAra (v) {

      //this.items = [{"id":"", "text":""}];

      if ((v!=null) && (v.length > 0)) {
        this.loading = true
        setTimeout(() => {
          this.$http.post(auth.API_URL + 'api/Coper/CariKodBul', {
            q: escape(v)
          }, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

            //var fitems = []
            //this.items = fitems

            this.items = [{"id":v, "text": this.$t('Current-Code-not-found') +"-"+v}]
            if(response.body!=null)
            {
              this.items[0].id = response.body.Kod;
              this.items[0].text = response.body.Aciklama;
            }


            //this.Error = false
          }, (response) => {
            if (response.status === 0) {
              //this.Success = false
              //this.Error = 'Service Unavailable'
            } else {
                //this.Success = false
                //this.Error = response.statusText
              }
            })
              this.loading = false
            }, 500)
        } else  {

        }
    }

  }
}


</script>